export default __webpack_public_path__ + "static/media/2.fac31c3d.jpg";